import { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setIsLoading,
  setIsUpdating,
  setShowContent,
} from "src/redux/features/loading-screen/loadingScreenSlice";

const MIN_LOADING_TIME = 750;
const MIN_UPDATING_TIME = 500;

const useChartLoadingScreen = (
  isLoading?: boolean,
  modifiedAt?: string
) => {
  const dispatch = useDispatch();
  const loadingStart = useRef<number | null>(null);
  const updatingTimeout = useRef<NodeJS.Timeout | null>(
    null
  );
  const lastModifiedAt = useRef<string | undefined>(
    modifiedAt
  );

  useEffect(() => {
    if (isLoading) {
      loadingStart.current = Date.now();
      dispatch(setIsLoading(true));
      dispatch(setShowContent(false));
    } else {
      if (loadingStart.current !== null) {
        const elapsed = Date.now() - loadingStart.current;
        const remaining = MIN_LOADING_TIME - elapsed;

        if (remaining > 0) {
          setTimeout(() => {
            dispatch(setIsLoading(false));
            dispatch(setShowContent(true));
          }, remaining);
        } else {
          dispatch(setIsLoading(false));
          dispatch(setShowContent(true));
        }

        loadingStart.current = null;
      }
    }
  }, [isLoading, dispatch]);

  useEffect(() => {
    if (
      modifiedAt &&
      modifiedAt !== lastModifiedAt.current
    ) {
      lastModifiedAt.current = modifiedAt;
      dispatch(setIsUpdating(true));

      if (updatingTimeout.current)
        clearTimeout(updatingTimeout.current);
      updatingTimeout.current = setTimeout(() => {
        dispatch(setIsUpdating(false));
      }, MIN_UPDATING_TIME);
    }
  }, [modifiedAt, dispatch]);
};

export default useChartLoadingScreen;
